import React, { useRef, useState } from "react";
import { useStore } from 'react-redux';
import request from '../../../../../../../../app/api/requests';
import { RootState, useAppDispatch } from '../../../../../../../../app/store';
import { rememberPendingSubscriptionPayment, syncSubscriptionAfterPayment, SubscriptionPayment } from '../../../../../../../../entities/subscription';
import { forgetPendingSubscriptionPayment, readPendingSubscriptionPayment } from '../../../../../../../../entities/subscription/model/pending-payment';
import { SubscriptionModal } from "../../../subscription-modal";
import "./lib/index.css";
import { Button } from "../../../../../../../../shared/ui/Button";
import { Checkbox } from "../../../../../../../../shared/ui/Checkbox/ui/Checkbox";
import { ReactComponent as ProtectIcon } from './lib/icons/protect-img.svg';
import { ReactComponent as ArrowRight } from "./lib/icons/ArrowRight.svg";
import { DiscountBage } from "../../bage";


interface EndProProp {
    initialPeriod?: 1 | 12,
    isOpenModal: boolean,
    closeModalAction: (act: boolean) => void
}

let orderCreate = [
    {period: 'year', total: '2 873 ', text:'Год'},
    {period: 'month', total: '399 ', text: 'Месяц'}
]

export function PaymentModal({isOpenModal, closeModalAction, initialPeriod = 12}:EndProProp) {
    const [countPeriod, setCountPeriod] = useState(initialPeriod === 12 ? 'year' : 'month');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const inFlight = useRef(false);
    const order = useRef<{ orderId: string; period: 1 | 12; expectedDateEnd?: string; userId: string } | null>(null);
    const store = useStore<RootState>();
    const dispatch = useAppDispatch();
    const [checkedPrivacy, setCheckedPrivacy] = useState(true);
    const orderDetails = orderCreate.find((el) => el.period === countPeriod)

    const pay = async () => {
        if (inFlight.current || !checkedPrivacy) return;
        const user = store.getState().userAuthSettings;
        if (!user.isAuth || !user.userId) { setError('Войдите в аккаунт для оплаты.'); return; }
        inFlight.current = true;
        setBusy(true);
        setError(null);
        try {
            const pending = readPendingSubscriptionPayment();
            // A previous ambiguous POST must be reconciled before creating another order.
            if (pending?.userId === user.userId && pending.orderId !== order.current?.orderId) {
                window.location.assign(`/subscription?orderId=${pending.orderId}`);
                return;
            }
            if (!order.current || order.current.userId !== user.userId) {
                order.current = {
                    orderId: crypto.randomUUID(), period: countPeriod === 'year' ? 12 : 1,
                    expectedDateEnd: store.getState().subscription.data?.dateEnd ?? undefined,
                    userId: user.userId,
                };
            }
            const { userId, ...body } = order.current;
            if (!rememberPendingSubscriptionPayment(body.orderId, userId)) {
                throw new Error('Не удалось сохранить заказ. Разрешите хранилище браузера и повторите попытку.');
            }
            const { data } = await request.post<SubscriptionPayment>('/Subscriptions/payments', body, { timeout: 15000 });
            const current = store.getState().userAuthSettings;
            if (!current.isAuth || current.userId !== userId) return;
            if (data.orderId?.toLowerCase() !== body.orderId.toLowerCase()) throw new Error('Сервер вернул другой заказ. Обновите подписку.');
            if (data.status === 'Succeeded' && data.appliedAt) {
                const result = await dispatch(syncSubscriptionAfterPayment(body.orderId)).unwrap();
                if (result.subscriptionUpdated) {
                    forgetPendingSubscriptionPayment(body.orderId, userId);
                    order.current = null;
                    closeModalAction(false);
                } else {
                    window.location.assign(`/subscription?orderId=${body.orderId}`);
                }
            } else if (data.confirmationUrl && data.status === 'Pending') {
                const url = new URL(data.confirmationUrl);
                if (url.protocol !== 'https:') throw new Error('Получена некорректная ссылка на оплату.');
                window.location.assign(url.href);
            } else {
                window.location.assign(`/subscription?orderId=${body.orderId}`);
            }
        } catch (cause) {
            setError(cause instanceof Error && !('isAxiosError' in cause) ? cause.message
                : 'Не удалось открыть оплату. Повторите попытку: сохранённый заказ не будет создан повторно.');
        } finally {
            inFlight.current = false;
            setBusy(false);
        }
    };
    
    return (
        <SubscriptionModal isOpenModal={isOpenModal} closeModalAction={closeModalAction} outsideClosing={true}>
            <SubscriptionModal.Header>
                <div className="payment-order">
                    <h1 className="end-trial-info__heading">Подтверждение платежа</h1>
                </div>
            </SubscriptionModal.Header>
            <SubscriptionModal.Content>
                <div style={{display: 'flex', flexDirection: 'column', gap: '28px', padding: '28px'}}>
                    <div style={{display: 'flex', gap: '12px', marginLeft: '14px'}}>
                        <Button disabled={busy || !!order.current} btnType="price" title="Ежемесячно · 399 ₽" onClickFunc={() => setCountPeriod('month')}/>
                        <div style={{position: 'relative'}}>
                            <DiscountBage>−40%</DiscountBage>
                            <Button disabled={busy || !!order.current} btnType="price" title="Ежегодно · 239 ₽/мес" onClickFunc={() => setCountPeriod('year')}/>
                        </div>
                    </div>
                    <div className="order-count">
                        <div className="order-count__info">
                            <p className="order-count__period">Тариф PRO • {orderDetails?.text}</p>
                            <p className="order-count__autopayment" style={{textTransform: 'lowercase'}}>автоматическое продление раз в {orderDetails?.text}</p>
                        </div>
                        <div className="order-count__info-total">
                            {
                                orderDetails?.period === 'year' &&
                                <p className="order-count__info-oldprice">4 788 ₽</p>
                            }
                            <p className="order-count__info-newprice">{orderDetails?.total} ₽</p>
                        </div>
                    </div>
                </div>
            </SubscriptionModal.Content>
            <SubscriptionModal.Footer>
                <div className="order-details" >
                    <Checkbox isChecked={checkedPrivacy} checkBoxAction={() => setCheckedPrivacy(!checkedPrivacy)}>
                        <p>
                                  Согласен с
                                  <a href="http://localhost:3000/privacy" rel="noreferrer" className="privacy-link" target="_blank" style={{marginLeft: '3px'}}>условиями оферты</a> 
                    </p>
                    </Checkbox>
                    {error && <p role="alert">{error}</p>}
                    <Button logo={<ArrowRight />} disabled={!checkedPrivacy || busy} loading={busy} onClickFunc={() => void pay()} stylesContainer={{width: '100%', display: 'flex', flexDirection: 'row-reverse', justifyContent: 'center', gap: '8px'}} btnType='filled' btnSize="xl" title="Перейти к оплате" />
                    <div style={{display: 'flex', flexDirection: 'row', gap: '2px', alignItems: 'center', justifyContent: 'center'}}>
                        <ProtectIcon />
                        <p style={{fontSize: '10px', color: 'rgba(148, 163, 189, 1)', lineHeight: '14px'}}>Откроется защащённая страница ЮКасса</p>
                    </div>
                </div>
            </SubscriptionModal.Footer>
        </SubscriptionModal>
    )
}
